/**
 * Shipper HQ
 *
 * @copyright Copyright (c) 2026 Zowta Ltd (http://www.shipperhq.com)
 * Copyright, 2026, Zowta, LLC - US license
 */

import React from 'react'
import ForgotPasswordFormView from './ForgotPasswordFormView'
import { useRedirectIfLoggedIn } from './hooks/useRedirectIfLoggedIn'
import { BrandsPanel } from './BrandsPanel'

export default function ForgotPasswordPage() {
    useRedirectIfLoggedIn()

    return (
        <main className="login-page">
            <section>
                <ForgotPasswordFormView />
            </section>
            <aside>
                <BrandsPanel />
            </aside>
        </main>
    )
}
